import { render, staticRenderFns } from "./HighlightProducts.vue?vue&type=template&id=563f2869&"
import script from "./HighlightProducts.vue?vue&type=script&lang=js&"
export * from "./HighlightProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563f2869')) {
      api.createRecord('563f2869', component.options)
    } else {
      api.reload('563f2869', component.options)
    }
    module.hot.accept("./HighlightProducts.vue?vue&type=template&id=563f2869&", function () {
      api.rerender('563f2869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/HighlightProducts.vue"
export default component.exports